import React, { useState } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Card } from './ui/card';
import { 
  Heart, 
  Flower, 
  Waves,
  Sun,
  ArrowRight,
  Users,
  Clock,
  Star,
  Sparkles,
  Leaf,
  Moon,
  Zap
} from 'lucide-react';

const WellnessPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Tous les Soins', icon: Heart },
    { id: 'massage', name: 'Massages', icon: Waves },
    { id: 'beauty', name: 'Beauté', icon: Flower },
    { id: 'wellness', name: 'Bien-être', icon: Sun },
    { id: 'meditation', name: 'Méditation', icon: Moon }
  ];

  const treatments = [
    {
      id: 1,
      category: 'massage',
      name: "Massage Signature PRIVIA",
      subtitle: "Rituel exclusif aux huiles rares",
      image: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "90 minutes",
      price: "€450",
      therapists: "2 thérapeutes",
      description: "Massage synchronisé à quatre mains avec des huiles précieuses d'argan et d'amande douce, dans l'intimité de votre villa.",
      benefits: ["Relaxation profonde", "Régénération cellulaire", "Évacuation du stress", "Harmonie corps-esprit"],
      includes: ["Consultation bien-être", "Huiles premium", "Musique relaxante", "Tisane détox"]
    },
    {
      id: 2,
      category: 'beauty',
      name: "Soin Visage Anti-Âge Diamant",
      subtitle: "Technologie de pointe et ingrédients précieux",
      image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "120 minutes",
      price: "€650",
      therapists: "1 esthéticienne expert",
      description: "Soin haut de gamme utilisant la poudre de diamant et des peptides bioactifs pour une peau éclatante et raffermie.",
      benefits: ["Effet lifting immédiat", "Hydratation intense", "Éclat du teint", "Réduction rides"],
      includes: ["Diagnostic de peau", "Masque diamant", "Sérum sur-mesure", "Crème de jour luxe"]
    },
    {
      id: 3,
      category: 'wellness',
      name: "Bain Rituel aux Sels Himalayens",
      subtitle: "Purification et minéralisation du corps",
      image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "60 minutes",
      price: "€320",
      therapists: "1 thérapeute spa",
      description: "Bain thérapeutique dans votre baignoire ou jacuzzi privé avec sels roses de l'Himalaya et huiles essentielles.",
      benefits: ["Détoxification", "Reminéralisation", "Apaisement musculaire", "Équilibre énergétique"],
      includes: ["Sels himalayens", "Bougies aromathérapie", "Thé détox", "Peignoir spa"]
    },
    {
      id: 4,
      category: 'meditation',
      name: "Séance Méditation Sonore",
      subtitle: "Voyage intérieur aux bols tibétains",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "75 minutes",
      price: "€280",
      therapists: "1 maître spirituel",
      description: "Méditation guidée avec bols chantants tibétains authentiques pour une relaxation profonde et un rééquilibrage énergétique.",
      benefits: ["Paix intérieure", "Clarté mentale", "Réduction anxiété", "Harmonie chakras"],
      includes: ["Bols tibétains", "Coussin méditation", "Encens naturel", "Guide audio personnel"]
    },
    {
      id: 5,
      category: 'massage',
      name: "Massage Pierres Chaudes Volcanique",
      subtitle: "Thérapie géothermale relaxante",
      image: "https://images.unsplash.com/photo-1596178065887-1198b6148b2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "105 minutes",
      price: "€520",
      therapists: "1 thérapeute certifié",
      description: "Massage aux pierres volcaniques chaudes combiné à des techniques de relaxation profonde pour libérer les tensions.",
      benefits: ["Décontraction musculaire", "Amélioration circulation", "Élimination toxines", "Bien-être général"],
      includes: ["Pierres volcaniques", "Huiles chauffées", "Serviettes chaudes", "Infusion énergisante"]
    },
    {
      id: 6,
      category: 'beauty',
      name: "Manucure & Pédicure Royal",
      subtitle: "Soins esthétiques complets",
      image: "https://images.unsplash.com/photo-1610651684391-74cc2006f038?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      duration: "150 minutes",
      price: "€380",
      therapists: "1 prothésiste ongulaire",
      description: "Soins complets des mains et pieds avec produits haut de gamme et techniques spa professionnelles.",
      benefits: ["Ongles parfaits", "Peau douce", "Relaxation", "Esthétique impeccable"],
      includes: ["Gommage exfoliant", "Masque hydratant", "Vernis premium", "Massage mains-pieds"]
    }
  ];

  const packages = [
    {
      name: "Journée Détox Complète",
      duration: "8 heures",
      price: "€1,200",
      treatments: ["Massage lymphatique", "Bain détox", "Soin visage purifiant", "Séance yoga"],
      image: "https://images.unsplash.com/photo-1545389336-cf090694435e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    },
    {
      name: "Week-end Régénération",
      duration: "2 jours",
      price: "€2,500",
      treatments: ["Massages quotidiens", "Soins visage anti-âge", "Méditations guidées", "Nutrition coach"],
      image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    },
    {
      name: "Retraite Bien-être 7 jours",
      duration: "1 semaine",
      price: "€4,800",
      treatments: ["Programme sur-mesure", "Thérapeutes dédiés", "Coaching holistique", "Suivi personnalisé"],
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    }
  ];

  const filteredTreatments = selectedCategory === 'all' 
    ? treatments 
    : treatments.filter(treatment => treatment.category === selectedCategory);

  const therapistSpecialties = [
    {
      icon: Waves,
      title: "Massothérapeutes Certifiés",
      description: "Experts formés aux meilleures techniques mondiales"
    },
    {
      icon: Flower,
      title: "Esthéticiennes de Luxe",
      description: "Spécialistes des soins visage et corps premium"
    },
    {
      icon: Sun,
      title: "Coachs Bien-être",
      description: "Accompagnement holistique corps-esprit"
    },
    {
      icon: Moon,
      title: "Maîtres Spirituels",
      description: "Guides expérimentés en méditation et énergétique"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* Hero Section */}
      <section className="relative py-20 px-6 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60" />
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <Badge 
            variant="secondary" 
            className="mb-6 px-6 py-3 bg-white/10 backdrop-blur-md border-white/20 text-white text-sm font-light uppercase tracking-wider"
          >
            <Heart className="w-4 h-4 mr-2" />
            Bien-être Absolu
          </Badge>
          
          <h1 
            className="text-5xl md:text-6xl font-light mb-6 tracking-wide"
            style={{ 
              fontFamily: 'Playfair Display, serif',
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
            }}
          >
            Spa & Bien-être
          </h1>
          
          <p 
            className="text-xl md:text-2xl font-light mb-12 opacity-90 max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Transformez votre villa en sanctuaire de bien-être avec nos thérapeutes experts et nos soins d'exception
          </p>

          <Button 
            size="lg"
            className="bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white px-8 py-4 rounded-full font-medium text-lg transition-all duration-300 transform hover:scale-105"
          >
            Réserver un Soin
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 px-6 bg-white/50 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => {
              const IconComponent = category.icon;
              return (
                <Button
                  key={category.id}
                  variant={selectedCategory === category.id ? 'default' : 'outline'}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full transition-all duration-300 ${
                    selectedCategory === category.id
                      ? 'bg-gradient-to-r from-green-600 to-teal-600 text-white shadow-lg transform -translate-y-1'
                      : 'bg-white/80 text-gray-700 border-gray-200 hover:bg-white/90 backdrop-blur-sm'
                  }`}
                >
                  <IconComponent className="w-4 h-4 mr-2" />
                  {category.name}
                </Button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Treatments */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 
              className="text-4xl font-light mb-6 text-gray-800"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Soins d'Exception
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Des rituels bien-être personnalisés dans l'intimité de votre villa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredTreatments.map((treatment) => (
              <Card key={treatment.id} className="overflow-hidden hover:shadow-2xl transition-all duration-500 group">
                <div className="relative h-64">
                  <img 
                    src={treatment.image}
                    alt={treatment.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-white/20 backdrop-blur-md border-white/30 text-white text-xs">
                      <Sparkles className="w-3 h-3 mr-1" />
                      Premium
                    </Badge>
                  </div>

                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <h3 
                      className="text-lg font-light mb-1"
                      style={{ fontFamily: 'Playfair Display, serif' }}
                    >
                      {treatment.name}
                    </h3>
                    <p className="text-xs opacity-90">{treatment.subtitle}</p>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="text-2xl font-light text-green-600">
                      {treatment.price}
                    </div>
                    <div className="text-xs text-gray-500 text-right">
                      <div className="flex items-center gap-1 mb-1">
                        <Clock className="w-3 h-3" />
                        <span>{treatment.duration}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Users className="w-3 h-3" />
                        <span>{treatment.therapists}</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {treatment.description}
                  </p>

                  <div className="space-y-2 mb-6">
                    <h4 className="font-medium text-gray-800 text-sm">Bienfaits :</h4>
                    <div className="grid grid-cols-2 gap-1">
                      {treatment.benefits.slice(0, 4).map((benefit, idx) => (
                        <div key={idx} className="flex items-center gap-1">
                          <Leaf className="w-3 h-3 text-green-600" />
                          <span className="text-xs text-gray-600">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <Button 
                    className="w-full bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white transition-all duration-300"
                    size="sm"
                  >
                    Réserver ce Soin
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Packages */}
      <section className="py-20 px-6 bg-gradient-to-r from-green-900 to-teal-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 
              className="text-4xl font-light mb-6"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Forfaits Bien-être
            </h2>
            <p 
              className="text-xl opacity-90 max-w-2xl mx-auto leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Des programmes complets pour une transformation profonde
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <Card key={index} className="p-6 bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/15 transition-all duration-300">
                <div className="relative h-40 mb-6 rounded-lg overflow-hidden">
                  <img 
                    src={pkg.image}
                    alt={pkg.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30" />
                </div>
                
                <h3 
                  className="text-xl font-light mb-3"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {pkg.name}
                </h3>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="text-2xl font-light text-green-300">
                    {pkg.price}
                  </div>
                  <div className="text-sm text-green-200">
                    {pkg.duration}
                  </div>
                </div>
                
                <div className="space-y-2 mb-6">
                  {pkg.treatments.map((treatment, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <Star className="w-3 h-3 text-green-400" />
                      <span className="text-sm text-green-100">{treatment}</span>
                    </div>
                  ))}
                </div>
                
                <Button 
                  variant="outline"
                  className="w-full border-green-300 text-green-300 hover:bg-green-300 hover:text-green-900"
                >
                  Découvrir ce Forfait
                </Button>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Therapist Specialties */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 
              className="text-4xl font-light mb-6 text-gray-800"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Notre Équipe d'Experts
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Des thérapeutes sélectionnés pour leur excellence et leur bienveillance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {therapistSpecialties.map((specialty, index) => {
              const IconComponent = specialty.icon;
              return (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <IconComponent className="w-8 h-8 text-green-600" />
                  </div>
                  
                  <h3 className="text-lg font-light text-gray-800 mb-4">{specialty.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{specialty.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-green-50 to-teal-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 
            className="text-4xl font-light mb-6 text-gray-800"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Votre Sanctuaire de Bien-être
          </h2>
          <p 
            className="text-xl mb-8 text-gray-600 leading-relaxed max-w-2xl mx-auto"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Créons ensemble votre espace de sérénité personnalisé avec nos thérapeutes d'exception
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white px-8 py-4 rounded-full font-medium text-lg transition-all duration-300 transform hover:scale-105"
            >
              Réserver une Séance
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-8 py-4 rounded-full font-medium text-lg transition-all duration-300"
            >
              Créer mon Programme
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-gray-600">
            <div className="flex items-center justify-center gap-2">
              <Heart className="w-4 h-4 text-green-600" />
              <span>Thérapeutes certifiés</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Zap className="w-4 h-4 text-green-600" />
              <span>Disponible 7j/7</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Sparkles className="w-4 h-4 text-green-600" />
              <span>Produits bio premium</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WellnessPage;